var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMerchToggleDisabled = function SvgMerchToggleDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "merch-toggle-disabled",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.929,
    height: 36.929
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108577",
    d: "M18.464 0A18.464 18.464 0 1 1 0 18.464 18.464 18.464 0 0 1 18.464 0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 4590 \\u2013 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.934 6.382a30.506 30.506 0 0 0-5.738 2.425c-.183.163-2.982 6.863-4.049 8.338-.125.2 4.815 2.06 5.732 2.422v11.97h14.863V19.57c.918-.362 5.858-2.221 5.732-2.422-1.066-1.476-3.866-8.176-4.049-8.338a30.489 30.489 0 0 0-5.735-2.428c-.734 2.784-6.023 2.782-6.756 0Z",
    "data-fill": "a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54994",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 4354",
    transform: "translate(14.219 11.198)",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.093,
    cy: 4.093,
    r: 4.093
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.093,
    cy: 4.093,
    r: 3.843
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 418",
    d: "m21.138 12.427-5.062 5.71"
  })))));
};
export default SvgMerchToggleDisabled;